import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-right-medium, dropdown, caret" maskId="round-filled-radius-1-stroke-1.5-IconChevronTriangleRightMedium"><path d="M9 7.82301C9 6.8275 10.0901 6.25678 10.8965 6.75173L11.0537 6.86598L16.0264 11.0427C16.6209 11.5423 16.621 12.4573 16.0264 12.9568L11.0537 17.1336C10.2405 17.8165 9.00018 17.2384 9 16.1765V7.82301Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
